module.exports = __webpack_public_path__ + "img/45_19.bb616fd0.png";